<template>
  <div class="myHome">
    <div class="zf" v-if="abox == false">
      <div class="back" @click="backorder()">返回</div>
      <div id="loc" ref="qrcode" class="rwm"></div>
      <div class="wphtitle" v-if="letc === '1'">微信支付</div>
      <div class="Yz" v-if="letc === '1'">
        {{ wxdata.icon }}{{ Number(wxdata.total_fee).toFixed(2) }}
      </div>
      <div class="jydh" v-if="letc === '1'">
        交易单号：{{ wxdata.out_trade_no }}
      </div>
    </div>
    <div v-if="isPhoneRechargeDebug" class="debug-panel">
      <div class="debug-head">
        <div class="debug-title">话费充值调试日志</div>
        <button class="debug-copy-btn" @click="copyDebugLogs">复制日志</button>
      </div>
      <div class="debug-list">
        <div v-for="(item, idx) in debugLogs" :key="`${idx}-${item.time}`" class="debug-item">
          <span class="debug-time">{{ item.time }}</span>
          <span class="debug-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qrcode from 'qrcodejs2'
import { settoken } from '@/utils/auth'
import { placeAnOrder, checkPay, appcheckPay,cateringOrderPlaceAnOrder,cateringOrderCheck, payPhoneRechargeConsume } from '@/API/user'
import utils from '@/utils/utils.js'

export default {
  name: 'myHome',
  data () {
    return {
      wxdata: {},
      letc: '',
      order_no: '',
      query: {},
      abox:true,
      isPhoneRechargeDebug: false,
      debugLogs: [],
      /** 已调起微信收银台，用于回前台 / 海外无回调时的查单兜底 */
      wxPayInvoked: false,
      payRedirected: false
    }
  },
  created () {
    console.log('进入当前页面', location)
    const params = {}
    // 替换&amp;为&
    if (location.href.indexOf('&amp%3B') != -1) {
      const decodedUrl = location.href.replace(/&amp%3B/g, '&')
      const urlObj = new URL(decodedUrl)

      urlObj.searchParams.forEach((value, key) => {
        if (key !== 'kbz_url') {
          params[key] = value
        }
      })
    } else {
      if (location.href.indexOf('source') != -1) {
        // 匹配kbz_url参数值
        const kbzUrlMatch = location.href.match(/kbz_url=([^&]+)/)
        if (kbzUrlMatch) {
          // 获取kbz_url值
          const kbzUrl = kbzUrlMatch[1]

          // 添加到参数对象
          params['kbz_url'] = kbzUrl
        }

        // 解析其他参数使用URL对象
        const urlObj = new URL(location.href)
        urlObj.searchParams.forEach((value, key) => {
          if (key !== 'kbz_url') {
            params[key] = value
          }
        })
      }

      console.log('tag', params, encodeURI(this.$route.query.kbz_url))
    }

    if (this.$route.query.source == 'app') {
      console.log(params)
      this.order_no = params.order_sn
      localStorage.setItem('query', JSON.stringify(params))
      let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
      top.location.href = encodeURI(this.$route.query.kbz_url)
      let headers = utils.getsign(
        {
          order_no: this.order_no
        },
        key
      )
      this.timer = setInterval(async () => {
        let data = await appcheckPay({
          order_no: this.order_no,
          sign: headers['x-sign']
        })
        if (data.error === 0) {
          console.log(data, this.$route.query)
          if (params.merchant_url.indexOf('?order_id=') != -1) {
            top.location.href = encodeURI(
              params.merchant_url + params?.order_no
                ? '&order_no=' + params.order_no
                : ''
            )
          } else {
            top.location.href = encodeURI(params.merchant_url)
          }
        }
      }, 4000)
    } else if (this.$route.query.source == 'zhichong') {
      this.order_no = params.order_sn
      localStorage.setItem('ZCquery', JSON.stringify(params))
      // let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
      top.location.href = encodeURI(this.$route.query.kbz_url)
    } else {
      if (this.$route.query.a) {
        let a = JSON.parse(this.$route.query.a)
        this.isPhoneRechargeDebug = !!(a && a.bizType === 'phoneRecharge') && this.isNonProductionEnv()
        console.log('[zf][created] query.a parsed:', a)
        // 话费充值：独立分流，避免走原商城微信分支
        if (a && a.bizType === 'phoneRecharge') {
          console.log('[zf][created][phoneRecharge] hit phoneRecharge branch, payMethod/isWx/openId:', a.payMethod, a.isWx, a.openId)
          this.creadersize()
          this.creaderdata()
          return
        }
        console.log(a, '找找isWx')
        console.log(a.isWx, '找找a.isWx')
        if (a.isWx) {
          // 调用微信的jsapi支付
          let data = a.data
          this.creadersize()
          this.wxdata = data || {}
          if (a.returnAddress) localStorage.setItem('returnAddress', a.returnAddress)
          if (a.storeId) localStorage.setItem('storeID', a.storeId)

          if(a.isXcx){
            const vm = this
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp:data.timeStamp , // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.paySign,// 必填，签名
              jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
            });
            wx.ready(function(){
              vm.wxPayInvoked = true
              wx.chooseWXPay({
                timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success () {
                  vm.redirectAfterWxPay(a, true)
                },
                cancel () {
                  vm.redirectAfterWxPay(a, false)
                },
                fail () {
                  vm.redirectAfterWxPay(a, false)
                }
              });
              // 海外微信 / 部分机型回调不可靠：查单兜底
              vm.startMallPayWatch(a, 3000)
            })
          }else {
            // // 检测支付环境中的 WeixinJSBridge
            setTimeout(() => {
              // alert(typeof window.WeixinJSBridge == 'undefined')
              if (typeof window.WeixinJSBridge == 'undefined') {
                const readyFn = () => this.onBridgeReady(data)
                if (document.addEventListener) {
                  console.log('来了1')
                  document.addEventListener('WeixinJSBridgeReady', readyFn, false)
                } else if (document.attachEvent) {
                  console.log('来了2')
                  document.attachEvent('WeixinJSBridgeReady', readyFn)
                  document.attachEvent('onWeixinJSBridgeReady', readyFn)
                }
              } else {
                console.log('WeixinJSBridge失败')
                this.onBridgeReady(data)
              }
            }, 1000)
          }
        } else {
          this.creadersize()
          this.creaderdata()
        }
        console.log(this.$route.query.a, '执行')
      } else {
        console.log(localStorage.getItem('query'))
        if (localStorage.getItem('query')) {
          console.log('1')
          this.query = JSON.parse(localStorage.getItem('query'))
          this.order_no = this.query.order_sn
          localStorage.removeItem('query')
          let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
          let headers = utils.getsign(
            {
              order_no: this.order_no
            },
            key
          )
          this.timer = setInterval(async () => {
            let data = await appcheckPay({
              order_no: this.order_no,
              sign: headers['x-sign']
            })
            if (data.error === 0) {
              console.log(data, this.$route.query)
              top.location.href = encodeURI(
                this.query.merchant_url + this.query?.order_no
                  ? this.query.order_no
                  : ''
              )
            }
          }, 4000)
        } else {
          console.log('2')
          let url =
            localStorage.getItem('returnAddress') +
            'usermy/myOorder?storeId=' +
            localStorage.getItem('storeID')
          location.href = encodeURI(url)
        }
      }
    }
  },
  mounted () {
    this.domain = window.location.hostname + '/submitAfterapp'
    document.addEventListener('visibilitychange', this.is_Visible)
    // iOS / 海外微信从收银台返回时，pageshow 比 visibilitychange 更稳
    window.addEventListener('pageshow', this.onPageShow)
  },
  destroyed () {
    document.removeEventListener('visibilitychange', this.is_Visible)
    window.removeEventListener('pageshow', this.onPageShow)
    if (this.watchDelayTimer) {
      clearTimeout(this.watchDelayTimer)
      this.watchDelayTimer = null
    }
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    /** 微信 JSAPI 成功判定：兼容海外版 err_msg 大小写 / 字段差异 */
    isWxPayOk (res) {
      if (!res) return false
      const msg = String(res.err_msg || res.errMsg || res.err_msg || '').toLowerCase()
      if (!msg) return false
      // get_brand_wcpay_request:ok / chooseWXPay:ok
      if (msg.indexOf(':ok') !== -1) return true
      if (msg === 'ok') return true
      return false
    },
    isWxPayCancel (res) {
      if (!res) return false
      const msg = String(res.err_msg || res.errMsg || '').toLowerCase()
      return msg.indexOf(':cancel') !== -1
    },
    buildCheckPayBody (a) {
      // 微信内 JSAPI 下单 type=11；payload 上未必带 type，勿误用订单其它 type 字段
      let type
      if (a && a.isWx) type = '11'
      else if (a && a.type != null && a.type !== '') type = a.type
      else type = this.resolveMallTypeForPhoneRecharge(a)
      return {
        type: type != null ? String(type) : '11',
        orderNo: a.orderNo,
        payeeSettingId: a.payeeSettingId,
        userId: a.userId,
        storeId: a.storeId
      }
    },
    /** 跳回商城订单列表；success=true 时带 paySuccess=1 */
    redirectAfterWxPay (a, success) {
      if (this.payRedirected) return
      if (!a || !a.returnAddress) return
      const storeId = encodeURIComponent(a.storeId)
      let url = ''
      if (a.foodOrder) {
        url = a.returnAddress + 'orderFood?storeId=' + storeId
      } else if (success) {
        url = this.buildOrderListPaySuccessUrl(a)
      } else {
        url = a.returnAddress + 'usermy/myOorder?storeId=' + storeId
      }
      if (!url) return
      this.payRedirected = true
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      // 参数已逐个 encodeURIComponent，不能再整体 encodeURI，否则 ￥ 会变成 %25EF%25BF%25A5
      location.href = url
    },
    /**
     * 海外微信常见：支付成功后不触发 JSAPI 回调，只回到 H5。
     * 用查单轮询确认支付后再跳转。
     */
    startMallPayWatch (a, delay = 0) {
      if (!a || a.foodOrder || a.bizType === 'phoneRecharge') return
      if (this.payRedirected) return
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.watchDelayTimer) {
        clearTimeout(this.watchDelayTimer)
        this.watchDelayTimer = null
      }
      const vm = this
      const body = this.buildCheckPayBody(a)
      const tick = async () => {
        if (vm.payRedirected) return
        try {
          const data = await checkPay(body)
          if (data && data.code === 200) {
            vm.redirectAfterWxPay(a, true)
          }
        } catch (e) {
          console.warn('[zf] checkPay watch', e)
        }
      }
      const start = () => {
        vm.watchDelayTimer = null
        if (vm.payRedirected) return
        tick()
        vm.timer = setInterval(tick, 2000)
      }
      if (delay > 0) this.watchDelayTimer = setTimeout(start, delay)
      else start()
    },
    /** 兼容 result 为 JSON 字符串 / 对象，或 JSAPI 参数直接平铺在 data 上 */
    resolveWxJsapiConfig (data) {
      if (!data || typeof data !== 'object') return { config: null }
      const result = data.result
      if (result && typeof result === 'object') return { config: result }
      if (typeof result === 'string') {
        const raw = result.trim()
        if (raw.startsWith('{') || raw.startsWith('[')) {
          try {
            return { config: JSON.parse(raw) }
          } catch (e) {
            console.error('[zf] 微信支付参数 JSON 解析失败', raw)
            return { config: null }
          }
        }
        if (raw && !data.appId && !data.package) return { redirect: raw }
      }
      return { config: data }
    },
    onPageShow (e) {
      // bfcache 返回或从微信收银台回来
      if (e && e.persisted) this.handleReturnFromWxPay()
      else if (this.wxPayInvoked) this.handleReturnFromWxPay()
    },
    handleReturnFromWxPay () {
      if (this.payRedirected || !this.wxPayInvoked) return
      if (!this.$route.query.a) return
      let a
      try {
        a = JSON.parse(this.$route.query.a)
      } catch (e) {
        return
      }
      if (!a || a.bizType === 'phoneRecharge') return
      // 回前台后立刻查单，成功再跳（避免取消支付误带 paySuccess）
      this.startMallPayWatch(a)
    },
    resolveMallTypeForPhoneRecharge (a) {
      const pm = Number(a && a.payMethod)
      if (pm === 0) return 0
      // 商城微信支付：微信内 type=11，微信外 type=4
      if (pm === 1) return a && a.isWx ? 11 : 4
      // 商城其余支付方式 type 对齐
      if (pm === 2) return 3
      if (pm === 3) return 5
      if (pm === 4) return 6
      if (pm === 5) return 8
      if (pm === 6) return 9
      if (pm === 7) return 10
      // 未命中时回退上游 payType
      if (a && a.payType != null && a.payType !== '') {
        const fallback = Number(a.payType)
        return Number.isNaN(fallback) ? undefined : fallback
      }
      return undefined
    },
    resolvePhoneRechargeConsumePayType (a) {
      const pm = Number(a && a.payMethod)
      if (pm === 2 || pm === 7) {
        if (
          a &&
          a.mallCurrencyPayType != null &&
          String(a.mallCurrencyPayType) !== '' &&
          String(a.mallCurrencyPayType) !== '0'
        ) {
          return String(a.mallCurrencyPayType)
        }
        if (a && a.payType != null && /[A-Za-z]{2,}/.test(String(a.payType))) {
          return String(a.payType)
        }
        return 'USD'
      }
      return undefined
    },
    buildPhoneRechargeConsumeParams (a) {
      const pm = Number(a && a.payMethod)
      const rawType = this.resolveMallTypeForPhoneRecharge(a)
      const typeStr =
        rawType != null && !Number.isNaN(Number(rawType)) ? String(rawType) : '0'
      const storeRaw =
        a && a.storeId != null && a.storeId !== ''
          ? a.storeId
          : localStorage.getItem('storeID')
      let paySettingId =
        a && a.paySettingId != null && a.paySettingId !== ''
          ? a.paySettingId
          : undefined
      // 与 saas-shop-frontend-h5 paryment.vue 一致：payMethod=3 时固定 000
      if (pm === 3) {
        paySettingId = '000'
      }
      const userId =
        a && a.userId != null && String(a.userId) !== '' ? String(a.userId) : undefined
      const params = {
        orderNo: String((a && a.orderNo) || ''),
        type: typeStr,
        paySettingId,
        userId,
        storeId: storeRaw != null && storeRaw !== '' ? String(storeRaw) : undefined,
        flag: a && a.flag != null ? a.flag : 0
      }
      // 后端新增字段（与 createPayOrder 一致，来源 previewOrder）：
      //   expectedCurrencyId  —— 用户当前页面看到的预期售价币种
      //   expectedSellingPrice—— 用户当前页面看到的预期售价
      // 上游（confirm.vue / orderDetail.vue）通过 routePayload 透传过来
      if (a && a.expectedCurrencyId != null && String(a.expectedCurrencyId) !== '') {
        const cid = Number(a.expectedCurrencyId)
        if (!Number.isNaN(cid)) params.expectedCurrencyId = cid
      }
      if (a && a.expectedSellingPrice != null && String(a.expectedSellingPrice) !== '') {
        params.expectedSellingPrice = a.expectedSellingPrice
      }
      const epayType = this.resolvePhoneRechargeConsumePayType(a)
      if (epayType != null) {
        params.payType = epayType
      }
      return params
    },
    /**
     * 仅在测试 / UAT / 本地环境允许显示话费充值调试面板。
     * 正式环境（线上域名）一律隐藏，避免给用户看到日志。
     */
    isNonProductionEnv () {
      try {
        const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
        if (!host) return false
        return /test|uat|dev|localhost|127\.0\.0\.1|192\.168\./i.test(host)
      } catch (e) {
        return false
      }
    },
    async copyDebugLogs () {
      if (!this.isPhoneRechargeDebug) return
      const text = this.debugLogs.map(item => `${item.time} ${item.text}`).join('\n')
      if (!text) {
        this.appendDebugLog('暂无可复制日志')
        return
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = text
          textarea.setAttribute('readonly', 'readonly')
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        this.appendDebugLog('日志已复制到剪贴板')
      } catch (e) {
        this.appendDebugLog('复制失败', e && e.message ? e.message : 'unknown error')
      }
    },
    appendDebugLog (text, detail) {
      if (!this.isPhoneRechargeDebug) return
      let suffix = ''
      if (detail !== undefined) {
        try {
          const raw = typeof detail === 'string' ? detail : JSON.stringify(detail)
          suffix = raw ? ` ${String(raw).slice(0, 400)}` : ''
        } catch (e) {
          suffix = ' [detail stringify failed]'
        }
      }
      const now = new Date()
      const time = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
      this.debugLogs.push({
        time,
        text: `${text}${suffix}`
      })
      if (this.debugLogs.length > 60) {
        this.debugLogs = this.debugLogs.slice(this.debugLogs.length - 60)
      }
    },
    debugPhoneRecharge (label, detail) {
      const isPhoneRecharge = this.$route && this.$route.query && this.$route.query.a && String(this.$route.query.a).indexOf('"bizType":"phoneRecharge"') !== -1
      if (!isPhoneRecharge) return
      let suffix = ''
      if (detail !== undefined) {
        try {
          const raw = typeof detail === 'string' ? detail : JSON.stringify(detail)
          suffix = raw ? `\n${String(raw).slice(0, 600)}` : ''
        } catch (e) {
          suffix = '\n[detail stringify failed]'
        }
      }
      const message = `[话费充值调试] ${label}${suffix}`
      console.log(message)
      this.appendDebugLog(label, detail)
    },
    onBridgeReady (data) {
      let a = JSON.parse(this.$route.query.a)
      const vm = this
      console.log('[zf][onBridgeReady] enter with data:', data)
      this.debugPhoneRecharge('进入 onBridgeReady', data)
      const { config: wxCofing, redirect } = this.resolveWxJsapiConfig(data)
      if (redirect) {
        this.debugPhoneRecharge('onBridgeReady 收到非JSON result，跳转 result', redirect)
        location.href = encodeURI(redirect)
        return
      }
      console.log('[zf][onBridgeReady] wx config parsed:', wxCofing)
      this.debugPhoneRecharge('解析微信配置', wxCofing)
      const cfg = wxCofing || {}
      const ts = cfg.timeStamp != null ? cfg.timeStamp : cfg.timestamp
      let params = {
        appId: cfg.appId, //公众号ID，由商户传入
        timeStamp: ts != null ? String(ts) : '', //时间戳，自1970年以来的秒数
        nonceStr: cfg.nonceStr, //随机串
        package: cfg.package,
        signType: cfg.signType || 'MD5', //微信签名方式：
        paySign: cfg.paySign //微信签名
      }
      console.log('[zf][onBridgeReady] invoke params:', params)
      this.debugPhoneRecharge('调用 WeixinJSBridge.invoke 参数', params)
      if (!params.appId || !params.timeStamp || !params.nonceStr || !params.package || !params.paySign) {
        console.error('[zf][onBridgeReady] 微信支付参数不完整，未调起收银台', { data, params })
        alert('微信支付参数获取失败，请返回重新支付')
        this.redirectAfterWxPay(a, false)
        return
      }
      if (!window.WeixinJSBridge || typeof window.WeixinJSBridge.invoke !== 'function') {
        console.error('[zf][onBridgeReady] WeixinJSBridge 不可用，请在微信客户端内打开')
        return
      }
      this.wxPayInvoked = true
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, function (res) {
        console.log('[zf][onBridgeReady] invoke callback res:', res)
        if (a && a.bizType === 'phoneRecharge') {
          const base = String(a.returnAddress || '').trim()
          console.log('[zf][onBridgeReady][phoneRecharge] callback, returnAddress:', base)
          if (base) {
            location.href = encodeURI(base)
          }
          return
        }
        if (vm.isWxPayOk(res)) {
          console.log('pay success')
          vm.redirectAfterWxPay(a, true)
          return
        }
        // 取消 / 失败：仍回订单列表（不带 paySuccess）；若回调未达则靠查单
        if (vm.isWxPayCancel(res) || String((res && (res.err_msg || res.errMsg)) || '').toLowerCase().indexOf(':fail') !== -1) {
          console.warn('[zf][onBridgeReady] 微信支付失败/取消:', res)
          vm.redirectAfterWxPay(a, false)
        }
      })
      // 海外版微信：前端回调不可靠，收银台调起后再延迟查单兜底
      if (!(a && a.bizType === 'phoneRecharge')) {
        this.startMallPayWatch(a, 3000)
      }
    },
    is_Visible: function (e) {
      if (!this.$route.query.source) {
        if (this.$route.query.a) {
          this.creadersize()
          let a = JSON.parse(this.$route.query.a)
          console.log('执行这里吗？', e.target.visibilityState)
          if (this.abox === true) {
            if (e.target.visibilityState === 'visible') {
              if (a.foodOrder) {
                // 点餐：保持原逻辑，不强跳
              } else if (a.bizType === 'phoneRecharge') {
                // 话费：不在此强跳
              } else if (a.isWx || String(a.type) === '11' || this.wxPayInvoked) {
                // 微信内支付（含海外）：回前台后查单确认再跳
                this.handleReturnFromWxPay()
              } else if (a.type === '1') {
                let b = {
                  type: '1',
                  orderNo: a.orderNo,
                  payeeSettingId: a.payeeSettingId,
                  userId: a.userId,
                  storeId: a.storeId
                }
                let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId + '&b=' + JSON.stringify(b) + '&paySuccess=1&orderNo=' + encodeURIComponent(a.orderNo || '')
                location.href = encodeURI(url)
              } else if (a.type === 2) {
                let b = {
                  type: '0',
                  orderNo: a.orderNo,
                  payeeSettingId: a.payeeSettingId,
                  userId: a.userId,
                  storeId: a.storeId
                }
                let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId + '&b=' + JSON.stringify(b) + '&paySuccess=1&orderNo=' + encodeURIComponent(a.orderNo || '')
                location.href = encodeURI(url)
              } else if (a.type === '6') {
                let b = {
                  type: '4',
                  orderNo: a.orderNo,
                  payeeSettingId: a.payeeSettingId,
                  userId: a.userId,
                  storeId: a.storeId
                }
                let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId + '&b=' + JSON.stringify(b) + '&paySuccess=1&orderNo=' + encodeURIComponent(a.orderNo || '')
                location.href = encodeURI(url)
              }
            }
          }
        } else {
          if (localStorage.getItem('query')) {
            this.query = JSON.parse(localStorage.getItem('query'))
            this.order_no = this.query.order_sn
            localStorage.removeItem('query')
            let key = '9bwht7zb5rmhv5ygmbicbz8vbmhnvp'
            let headers = utils.getsign(
              {
                order_no: this.order_no
              },
              key
            )
            this.timer = setInterval(async () => {
              let data = await appcheckPay({
                order_no: this.order_no,
                sign: headers['x-sign']
              })
              if (data.error === 0) {
                console.log(data, this.$route.query)
                top.location.href = encodeURI(
                  this.query.merchant_url + this.query?.order_no
                    ? this.query.order_no
                    : ''
                )
              }
            }, 4000)
          } else {
            console.log('3')
            let url =
              localStorage.getItem('returnAddress') +
              'usermy/myOorder?storeId=' +
              a.storeId
            location.href = encodeURI(url)
          }
        }
      }
    },
    backorder () {
      let a = JSON.parse(this.$route.query.a)
      if(a.jumpList==true){
        let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId
        location.href = encodeURI(url)
      }else {
        let url = a.returnAddress + 'usermy/myOorder?storeId=' + a.storeId
        location.href = encodeURI(url)
      }

    },
    // 监听屏幕宽度
    creadersize () {
      // 通过捕获系统的onresize事件触发我们需要执行的事件
      let w = window.innerWidth
      let a = false
      if (w > 767) {
        a = false
      } else {
        a = true
      }
      this.abox = a
    },
    /** 支付成功回商城订单列表，附带 pixel Purchase 识别参数 */
    buildOrderListPaySuccessUrl (a) {
      if (!a || !a.returnAddress) return ''
      let url =
        a.returnAddress +
        'usermy/myOorder?storeId=' +
        encodeURIComponent(a.storeId) +
        '&paySuccess=1'
      if (a.orderNo) {
        url += '&orderNo=' + encodeURIComponent(a.orderNo)
      }
      const wx = this.wxdata || {}
      const payAmount = a.payAmount && typeof a.payAmount === 'object' ? a.payAmount : {}
      // V2 下单返回 amountTotal / price，旧版为 total_fee
      const fee = [wx.amountTotal, wx.price, wx.total_fee, payAmount.amount, a.totalPrice]
        .find(v => v != null && v !== '' && !isNaN(Number(v)))
      if (fee != null) {
        url += '&amount=' + encodeURIComponent(fee)
      }
      const cur = wx.icon || payAmount.currencyIcon || a.icon
      if (cur) {
        url += '&currency=' + encodeURIComponent(cur)
      }
      return url
    },
    //  间隔两面查询订单支付状态
    async inquireState () {
      let a = JSON.parse(this.$route.query.a)
      if(a.foodOrder){
        console.log('第一步');
        
        if(a.type=='2'){
          let b = {
            type:1,
            orderNo: this.wxdata.orderNo
          }
          console.log('第二步',this.wxdata);
          this.timer = setInterval(async () => {
            let data = await cateringOrderCheck(b)
            if (data.code === 200) {
              let url = a.returnAddress + 'orderFood?storeId='+a.storeId
              location.href = encodeURI(url)
            }
          }, 4000)
        }
      }else if (a.type === '1') {
        if (this.abox === false) {
          let b = {
            type: '1',
            orderNo: a.orderNo,
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: a.storeId
          }
          this.timer = setInterval(async () => {
            let data = await checkPay(b)
            if (data.code === 200) {
              let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
              location.href = encodeURI(url)
            }
          }, 4000)
        } else {
          let b = {
            type: '1',
            orderNo: a.orderNo,
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: a.storeId
          }
          this.timer = setInterval(async () => {
            let data = await checkPay(b)
            if (data.code === 200) {
              // console.log(data)
              let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
              console.log(data, url)
              location.href = encodeURI(url)
            }
          }, 4000)
        }
      } else if (a.type === 2) {
        let b = {
          type: '0',
          orderNo: a.orderNo,
          payeeSettingId: a.payeeSettingId,
          userId: a.userId,
          storeId: a.storeId
        }
        this.timer = setInterval(async () => {
          let data = await checkPay(b)
          if (data.code === 200) {
            let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
            location.href = encodeURI(url)
          }
        }, 1000)
      } else if (a.type === '6') {
        let b = {
          type: '4',
          orderNo: a.orderNo,
          payeeSettingId: a.payeeSettingId,
          userId: a.userId,
          storeId: a.storeId
        }
        this.timer = setInterval(async () => {
          let data = await checkPay(b)
          if (data.code === 200) {
            let url = a.returnAddress + 'Successhtml?value=true'+'&b='+JSON.stringify(b)+'&storeId='+a.storeId
            console.log(data, url)
            location.href = encodeURI(url)
          }
        }, 4000)
      }
    },
    getQRcode (data) {
      this.creadersize()
      if (this.abox === false) {
        new Qrcode(this.$refs.qrcode, {
          // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
          text: data,
          width: 200,
          height: 200,
          colorDark: '#333', //二维码颜色
          colorLight: '#fff', //二维码背景颜色
          correctLevel: Qrcode.CorrectLevel.L //容错率,L/M/H
        })
      } else {
        new Qrcode(this.$refs.qrcode, {
          // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
          text: data,
          width: 300,
          height: 300,
          colorDark: '#333', //二维码颜色
          colorLight: '#fff', //二维码背景颜色
          correctLevel: Qrcode.CorrectLevel.L //容错率,L/M/H
        })
      }
    },
    // 初始化获取订单打开支付
    async creaderdata () {
      console.log('=== creaderdata方法开始执行 ===')
      let a = JSON.parse(this.$route.query.a)
      console.log('[zf][creaderdata] 解析的a参数:', a)
      if (a && a.bizType === 'phoneRecharge') {
        this.debugPhoneRecharge('命中话费充值分支', {
          payMethod: a.payMethod,
          isWx: a.isWx,
          openId: a.openId,
          orderNo: a.orderNo
        })
        console.log('[zf][creaderdata][phoneRecharge] start, payMethod/isWx/openId:', a.payMethod, a.isWx, a.openId)
        localStorage.setItem('returnAddress', a.returnAddress || '')
        localStorage.setItem('storeID', String(a.storeId || ''))
        if (a.token) settoken(a.token)
        const params = this.buildPhoneRechargeConsumeParams(a)
        // 仅微信内微信支付时透传 openId
        if (Number(a.payMethod) === 1 && a.isWx && a.openId) {
          params.openId = String(a.openId)
        }
        if (a.remark != null && String(a.remark).trim()) {
          params.remark = String(a.remark).trim()
        }
        console.log('[zf][creaderdata][phoneRecharge] payPhoneRechargeConsume params:', params)
        this.debugPhoneRecharge('准备调用 payPhoneRechargeConsume', params)
        const { data } = await payPhoneRechargeConsume(params)
        console.log('[zf][creaderdata][phoneRecharge] payPhoneRechargeConsume response data:', data)
        this.debugPhoneRecharge('payPhoneRechargeConsume 返回', data)
        if (a.isWx && data) {
          console.log('[zf][creaderdata][phoneRecharge] isWx=true, go onBridgeReady')
          console.log('[zf][creaderdata][phoneRecharge] WeixinJSBridge exists:', typeof window.WeixinJSBridge !== 'undefined')
          this.debugPhoneRecharge('isWx=true，准备调起微信JSAPI', {
            hasBridge: typeof window.WeixinJSBridge !== 'undefined'
          })
          if (data && typeof data.result === 'string' && String(data.result).trim().indexOf('weixin://') === 0) {
            this.debugPhoneRecharge('检测到 weixin:// 链接，直接跳转', data.result)
            location.href = encodeURI(String(data.result))
            return
          }
          this.onBridgeReady(data)
          return
        }
        const payUrl = (data && (data.payUrl || data.pay_url || data.result || data.url)) || ''
        console.log('[zf][creaderdata][phoneRecharge] resolved payUrl:', payUrl)
        this.debugPhoneRecharge('解析 payUrl', payUrl)
        if (payUrl) {
          console.log('[zf][creaderdata][phoneRecharge] redirect to payUrl')
          this.debugPhoneRecharge('跳转 payUrl', payUrl)
          top.location.href = encodeURI(String(payUrl))
          return
        }
        const redirectBase = String(a.returnAddress || '').trim()
        console.log('[zf][creaderdata][phoneRecharge] fallback returnAddress:', redirectBase)
        this.debugPhoneRecharge('未拿到 payUrl，回落 returnAddress', redirectBase)
        if (redirectBase) {
          // top.location.href = encodeURI(redirectBase)
          return
        }
        // top.location.href = encodeURI('/s/phonebill/orderList')
        return
      }
      localStorage.setItem('returnAddress', a.returnAddress)
      localStorage.setItem('storeID', a.storeId)
      settoken(a.token)
      this.letc = a.type
      this.creadersize()
      console.log('支付接口调用')
      console.log('abox值:', this.abox, 'payMethod:', a.payMethod, 'foodOrder:', a.foodOrder)
      if (this.abox === true) {
        if (a.payMethod == 1) {
          console.log('进入payMethod == 1分支')
          let data1 = {
            orderNo: a.orderNo,
            type: '4',
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: a.storeId,
            flag:a.flag
          }
        if(a.foodOrder){
          console.log('进入foodOrder分支，data1:', data1);
          data1.type = '4'
          try {
            console.log('准备调用cateringOrderPlaceAnOrder，参数:', data1);
            let { data } = await cateringOrderPlaceAnOrder(data1)
            console.log('到达这里了',data);
            
            if (data) {
              this.wxdata = data
              if(data.result){
                location.href = data.result
              }else {
                // location.href = data.h5_url
              }
            } else {
              console.log('data为空或undefined');
            }
          } catch (error) {
            console.error('cateringOrderPlaceAnOrder调用出错:', error);
            console.error('错误详情:', error.message, error.stack);
          }
        }else{
          let { data } = await placeAnOrder(data1)
          if (data) {
            this.wxdata = data
            if(data.result){
              location.href = data.result
            }else {
              // location.href = data.h5_url
            }
          }
    
        }
        } else if (a.payMethod === 4) {
          let data1 = {
            orderNo: a.orderNo,
            type: '6',
            payeeSettingId: a.payeeSettingId,
            userId: a.userId,
            storeId: localStorage.getItem('storeID'),
            flag:a.flag
          }
          let { data } = await placeAnOrder(data1)
          if (data) {
            location.href = data.qr_url || data.qr_code
          }
          console.log(data.qr_url || data.qr_code)
          // location.href = data.qr_code
          console.log(data)
        }
      } else {
        let data1 = {
          orderNo: a.orderNo,
          type: '2',
          payeeSettingId: a.payeeSettingId,
          userId: a.userId,
          storeId: a.storeId,
          flag:a.flag
        }
        let { data } = await placeAnOrder(data1)
        this.getQRcode(data.result?data.result:data.code_url)
        this.wxdata = data
      }
      this.inquireState()
    }
  }
  // beforeDestroy() {
  // 	clearInterval(this.timer);
  // },
}
</script>

<style>
.myHome {
  width: 100%;
  min-height: 910px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}

.zf {
  width: 800px;
  height: 800px;
  border: 1px solid #c7c6c6;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.back {
  cursor: pointer;
  position: absolute;
  width: 65px;
  height: 30px;
  border: 1px solid #6e4faa;
  border-radius: 15px;
  line-height: 30px;
  font-family: 'Microsoft YaHei';
  text-align: center;
  color: #6e4faa;
  font-weight: 600;
  left: 10px;
  top: 10px;
}

.wphtitle {
  margin-top: 30px;
}

.Yz {
  margin-top: 20px;
  font-size: 30px;
  font-family: 'Microsoft YaHei';
  font-weight: normal;
  color: #ff4545;
}

.jydh {
  margin-top: 20px;
  color: rgb(189, 189, 189);
}

.debug-panel {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: 8px;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  border-radius: 8px;
  padding: 8px;
  max-height: 42vh;
  overflow: hidden;
  box-sizing: border-box;
}

.debug-title {
  font-size: 12px;
  font-weight: 600;
}

.debug-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.debug-copy-btn {
  border: none;
  background: #2f7ef7;
  color: #fff;
  font-size: 11px;
  border-radius: 4px;
  padding: 3px 8px;
  line-height: 1.2;
}

.debug-list {
  max-height: calc(42vh - 28px);
  overflow-y: auto;
}

.debug-item {
  font-size: 11px;
  line-height: 1.4;
  margin-bottom: 4px;
  word-break: break-all;
}

.debug-time {
  color: #90caf9;
  margin-right: 6px;
}

.debug-text {
  color: #fff;
}
</style>
